import loadingComponent from './loading.vue';
export default {
  // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
  install: function(Vue, ops = {}){

    if (Vue) {
      const LOADING = Vue.extend(loadingComponent);
      const instance = new LOADING({
        el: document.createElement('div')
      });
    
      let loading = {
        /** 
                 * 显示加载动画
                 * @param {Object} el 元素对象
                 */
        show(el) {
          let element = el || document.body;
          instance.show = true;
          element.appendChild(instance.$el);
        },
    
        /** 
                 * 关闭加载动画
                 * @param {Object} el 元素对象
                 */
        hide() {
          instance.show = false;
        }
      };
      Vue.prototype.$loading = loading;
      instance.type = ops.type || 'loading-one';
      return loading;
    }
  }
};